export enum BazaNcRecurringTransactionStatus {
    InProgress = 'InProgress',
    Stopped = 'Stopped',
    Cancelled = 'Cancelled',
}
